/**
 * Angular imports
 */
import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[papAutoTrim]'
})
export class AutoTrimDirective {

  constructor(@Optional() private readonly ngControl: NgControl) { }

  /**
   * On input, trim the value and update the control
   */
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (this.ngControl && typeof value === 'string' && value.length > 0) {
      /**
       * If value contains ONLY whitespace, clear it
       */
      if (value.trim() === '') {
        this.ngControl.control?.setValue('', { emitEvent: false });
      }
    }
  }

  /**
   * On blur, trim the value and update the control
   */
  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (this.ngControl && typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue !== value) {
        this.ngControl.control?.setValue(trimmedValue);
      }
    }
  }
}
